module.exports = __webpack_public_path__ + "img/logo.8845a70d.jpg";